import { lowerCase, toLower, toNumber } from "lodash";
import i18n from "../../i18n/i18n-config";
import { mapMonths } from "../../utils/properties";
import { formatNumber, getClassName } from "../../utils/utilities";

const SET_ALL_BILLING_VALUE = "SET_ALL_BILLING_VALUE";
const SET_VALUE = "SET_VALUE";
const RESET_BILLINGPLAN = "RESET_BILLINGPLAN";
const SET_VALUE_PRODUCTION_FORM = "SET_VALUE_PRODUCTION_FORM";
const SET_VALUE_BILLING_FORM = "SET_VALUE_BILLING_FORM";
const SET_VALUE_BILLING_ADJ_FORM = "SET_VALUE_BILLING_ADJ_FORM";
const REFRESH_DATA = "REFRESH_DATA";
const RELOAD_COLUMNS = "RELOAD_COLUMNS";

export function setAllValues(data, year, canEdit, canEditController, currentLanguage, projectManagement) {
  return {
    type: SET_ALL_BILLING_VALUE,
    data,
    year,
    canEdit,
    canEditController,
    currentLanguage, // Is necessary for change language columns
    projectManagement,
  };
}

export function setValue(index, value) {
  return {
    type: SET_VALUE,
    index,
    value,
  };
}

export function setValueProductionForm(value, month, index) {
  return {
    type: SET_VALUE_PRODUCTION_FORM,
    index,
    value,
    month,
  };
}

export function setValueBillingForm(value, month, index) {
  return {
    type: SET_VALUE_BILLING_FORM,
    index,
    value,
    month,
  };
}

export function setValueBillingAdjForm(value, month, index) {
  return {
    type: SET_VALUE_BILLING_ADJ_FORM,
    index,
    value,
    month,
  };
}

export function resetBillingManagement() {
  return {
    type: RESET_BILLINGPLAN,
  };
}

export function refreshData(paylod) {
  return {
    type: REFRESH_DATA,
    paylod,
  };
}

export function reloadColumns(currentLanguage, canEdit, canEditController, projectManagement) {
  return {
    type: RELOAD_COLUMNS,
    currentLanguage,
    canEdit,
    canEditController,
    projectManagement,
  };
}

const INIT_STATE = {
  alert: false,
  closed: false,
  consValueOpenMonth: 0,
  openMonth: "",
  openYear: 0,
  filterYear: 0,
  values: {},
  tableBilling: [],
  tableProduction: [],
  isDirtyProductionForm: false,
  isDirtyBillingForm: false,
  isDirtyBillingAdjForm: false,
  productionForm: [],
  billingForm: [],
  billingAdjForm: [],
  columnstableBilling: [],
  refreshData: null,
  refreshColumns: 0,
  actLanguage: null,
};

let counter = 0;

function columns(state, values, currentLanguage) {
  const columnstableBilling = [
    {
      title: i18n.t("projectsManagement.planning.billingPlan.activityResource"),
      dataIndex: "activity",
      width: 200,
      fixed: "left",
      render: (_, row) => i18n.t(`projectsManagement.planning.billingPlan.${row.key}`),
    },
  ];
  Object.keys(values.INVOICE_PLAN).forEach((cvm) => {
    if (cvm !== "key") {
      if (mapMonths[lowerCase(cvm)] !== undefined || cvm === "PRESENT") {
        const timeMonth = getClassName(cvm, state.openMonth, state.openYear, state.filterYear);
        // Months
        if (cvm !== "PRESENT") {
          // Print column only if not "PRESENT" column
          if (timeMonth === "present") {
            // If I'm in current month, I print the double column
            if (state.closed) {
              columnstableBilling.push({
                title: i18n.t(`projectsManagement.planning.billingPlan.${toLower(cvm)}`),
                width: 100,
                className: "table-value-right past",
                dataIndex: cvm,
                render: (amount) =>
                  formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
              });
            } else {
              columnstableBilling.push({
                title: `${i18n.t(`projectsManagement.planning.billingPlan.${toLower(cvm)}`)} plan`,
                width: 100,
                dataIndex: cvm,
                className: "table-value-right",
                render: (amount) =>
                  formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
              });
              columnstableBilling.push({
                title: `${i18n.t(`projectsManagement.planning.billingPlan.${toLower(cvm)}`)} act`,
                width: 100,
                dataIndex: "PRESENT",
                className: `table-value-right ${timeMonth}`,
                month: cvm,
              });
            }
          } else {
            columnstableBilling.push({
              title: i18n.t(`projectsManagement.planning.billingPlan.${toLower(cvm)}`),
              width: 100,
              dataIndex: cvm,
              className: `table-value-right ${timeMonth}`,
            });
          }
        }
      } else {
        // AP, AS, Total
        columnstableBilling.push({
          title: i18n.t(`projectsManagement.planning.billingPlan.${toLower(cvm)}`),
          width: 100,
          dataIndex: cvm,
          fixed: cvm === "AP" ? "left" : "right",
          className: "table-value-right",
          render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
        });
      }
    }
  });
  return columnstableBilling;
}

export default function EditableTableDuck(state = INIT_STATE, action) {
  let newState = Object.assign({}, state);
  const dataValues = {};
  const tableBilling = [];
  const tableProduction = [];
  const customFormP = [];
  const customFormB = [];
  const customFormA = [];
  switch (action.type) {
    case SET_ALL_BILLING_VALUE:
      newState = action.data;
      action.data.values.forEach((val) => {
        dataValues[val.type] = {};
        switch (val.type) {
          case "INVOICE_PLAN":
            dataValues[val.type] = val.columnValueMap;
            dataValues[val.type].key = val.type;
            dataValues[val.type].PRESENT = action.data.consValueOpenMonth;
            if (action.data.closed) {
              // If month is closed, i must show consValueOpenMonth of actual month
              dataValues[val.type][action.data.openMonth] = action.data.consValueOpenMonth;
            }
            tableBilling.push(dataValues[val.type]);
            // Form
            Object.keys(val.columnValueMap).forEach((cvm) => {
              if (mapMonths[lowerCase(cvm)] !== undefined) {
                const timeMonth = getClassName(cvm, newState.openMonth, newState.openYear, action.year);
                if (timeMonth === "future" && action.canEdit) {
                  customFormB.push({
                    month: mapMonths[lowerCase(cvm)],
                    amount: val.columnValueMap[cvm],
                  });
                }
              }
            });
            break;
          case "ADJUSTMENT_INVOICE_PLAN":
            // In actual month, I see the adjustment value month in Present and the actual month is "0"
            dataValues[val.type] = val.columnValueMap;
            dataValues[val.type].key = val.type;
            dataValues[val.type].PRESENT = val.columnValueMap[action.data.openMonth];
            if (!action.data.closed && toNumber(action.data.openYear) === toNumber(action.year)) {
              dataValues[val.type][action.data.openMonth] = "-";
            }
            tableBilling.push(dataValues[val.type]);
            // Form
            customFormA.push({
              month: mapMonths[lowerCase(action.data.openMonth)],
              amount: action.data.consValueOpenMonth,
            });
            break;
          case "INVOICE_PLAN_ADJUSTED":
            dataValues[val.type] = val.columnValueMap;
            dataValues[val.type].key = val.type;
            dataValues[val.type].PRESENT = val.columnValueMap[action.data.openMonth];
            if (!action.data.closed && toNumber(action.data.openYear) === toNumber(action.year)) {
              dataValues[val.type][action.data.openMonth] = "-";
            }
            tableBilling.push(dataValues[val.type]);
            break;
          case "ADJUSTMENT":
            dataValues[val.type] = val.columnValueMap;
            dataValues[val.type].key = val.type;
            tableProduction.push(dataValues[val.type]);
            Object.keys(val.columnValueMap).forEach((cvm) => {
              if (mapMonths[lowerCase(cvm)] !== undefined) {
                const timeMonth = getClassName(cvm, newState.openMonth, newState.openYear, action.year);
                if ((timeMonth === "future" || timeMonth === "present") && action.canEdit) {
                  customFormP.push({
                    month: mapMonths[lowerCase(cvm)],
                    amount: val.columnValueMap[cvm],
                  });
                }
              }
            });
            break;
          case "PRODUCTION_VALUE":
          case "PRODUCTION_ADJUSTED":
            dataValues[val.type] = val.columnValueMap;
            dataValues[val.type].key = val.type;
            tableProduction.push(dataValues[val.type]);
            break;
          default:
            break;
        }
      });
      newState.filterYear = action.year;
      newState.dataValues = dataValues;
      newState.tableBilling = tableBilling;
      newState.tableProduction = tableProduction;
      newState.isDirtyProductionForm = false;
      newState.isDirtyBillingForm = false;
      newState.isDirtyBillingAdjForm = false;
      newState.productionForm = customFormP;
      newState.billingForm = customFormB;
      newState.billingAdjForm = customFormA;
      newState.columnstableBilling = columns(newState, dataValues, action.currentLanguage);
      newState.refreshData = false;
      newState.refreshColumns = counter++;
      newState.actLanguage = action.currentLanguage;
      break;
    case SET_VALUE:
      newState[action.index] = action.value;
      break;
    case SET_VALUE_PRODUCTION_FORM:
      newState.isDirtyProductionForm = true;
      newState.productionForm[action.index].amount = action.value;
      break;
    case SET_VALUE_BILLING_FORM:
      newState.isDirtyBillingForm = true;
      newState.billingForm[action.index].amount = action.value;
      break;
    case SET_VALUE_BILLING_ADJ_FORM:
      newState.isDirtyBillingAdjForm = true;
      newState.billingAdjForm[action.index].amount = action.value;
      break;
    case RESET_BILLINGPLAN:
      newState = INIT_STATE;
      counter = 0;
      break;
    case REFRESH_DATA:
      newState.refreshData = action.paylod;
      break;
    case RELOAD_COLUMNS:
      newState.columnstableBilling = columns(newState, newState.dataValues, action.currentLanguage);
      break;
    default:
      break;
  }
  return newState;
}
